export default defineAppConfig({
  ui: {
    primary: 'byhours',
    // gray: 'slate'
  },
  icon: {
    provider: 'iconify',
    serverBundle: false,
  }
})